
<div class="border-div margin0 min-heightcontainer">
  <div class="floatinghead floatinghead-xs clearfix">
    <div class="row">
      <div class="col-sm-3 cf">
        <h2 class="mainhead d-flex"><span class="text">Offer Matrix</span></h2>
      </div>
      <div class="col-sm-9">
        <div class="d-flex align-item-center justify-content-end  floatinghead-right margin-bottom-15">
          <div class="search-sec be-search-01 d-flex margin-right-15">
            <input class="form-control" type="text" [(ngModel)]="searchText" (keyup)="onSearch($event.target.value)" placeholder="Search">
            <i class="fa fa-search icon" aria-hidden="true"></i>
          </div>
          <div class="input-group d-flex align-item-center">
            <label class="select inline-block flex-grow-1" style="display:inline-block;">
              <select #mySelect (change)='groupData(mySelect.value)' class="form-control" [(ngModel)]="GroupbyId">
                <option value="0">Group By</option>
                <option value="1">Company</option>
                <option value="2">Buyer</option>
                <option value="3">Property / Portfolio</option>
                <option value="4">Status</option>
              </select>
              <i></i>
            </label>
            <button (click)="groupData(0)" class="btn-border btn adduserbtn margin-left-10 margin-right-10" tooltip="Reset Offer Matrix" placement="top"><i aria-hidden="true" class="icon-reset"></i></button>
            <button _ngcontent-oie-c8="" *ngIf="(authService.Broker() || authService.Admin() || authService.SuperAdmin()) && IsArchive=='0'&&(propertyStatus=='351'||propertyStatus=='356')" (click)="focusPlaceOffer()" class="btn btn-success pull-right btn-lg">Place Offer</button>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table basictable row-border hover" datatable [dtOptions]="dtOptions">
        <thead>
          <tr>

            <th data-orderable="false"></th>
            <th data-orderable="false">Action</th>
            <th data-orderable="false" [hidden]="(!this.authService.Broker()&&!this.authService.Principal()&&!this.authService.Principal1031()&&!this.authService.ExternalBroker() && !this.authService.Admin() && !this.authService.SuperAdmin())">Questionnaire</th>
            <th>Offer Placed By</th>
            <th>Buyer Company</th>
            <th>Last Modified User</th>
            <th class="min-width-75">Property<br />/Portfolio</th>
            <th>On Behalf Of</th>
            <th [hidden]="hideBroker">Broker</th>
            <th>Asking Price</th>
            <!--<th>Offer Type</th>-->
            <th>Offer Date</th>
            <th>Offer Price</th>
            <th>Offer Cap Rate</th>
            <th>Earnest Money Deposit</th>
            <th>Due Diligence Period (Days)</th>
            <th>Closing Period (Days)</th>
            <!--<th>Comments</th>-->
            <th>Status</th>
            <th>Rating</th>


          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let type of offerList;let p = index">
            <tr *ngIf="type.Key">
              <td class="sticky-left">
                <p class="whitespacenowrap">{{type.Key}}</p>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td [hidden]="hideBroker"></td>
              <td></td>
              <!--<td></td>-->
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>

            </tr>
            <ng-container *ngIf="type.Values.length > 0">
              <ng-container *ngFor="let offer of type.Values; let i= index;">
                <tr [class.portfoio-list]="offer.PropertyOrPortfolio != 'Single'">
                  <td class="first-td"></td>
                  <td class="whitespacenowrap">
                    <div class="d-flex align-items-center">
                      <div class="displayinlineblockdiv">
                        <a *ngIf="authService.Admin() || authService.SuperAdmin() || this.authService.Broker()" class="view" (click)="openOfferEditPopup(templateOfferPopup,offer.OfferDetailGuid,'offermodal')" ng-reflect-placement="top" ng-reflect-tooltip="Edit" placement="top" tooltip="Edit" triggers="hover">
                          <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                        </a>
                      </div>
                      <div *ngIf="(offer.IsDraft) && (authService.Principal() || authService.Principal1031() || authService.ExternalBroker()) && !isPropertySeller" class="displayinlineblockdiv">
                        <a href="javascript:void(0);" [ngClass]="{'disable-link':IsPDeleted}" routerLink="/place-offer/{{propertyGuid}}/{{offer.OfferDetailGuid}}/{{fromPage}}" class="blueone" tooltip="Modify" placement="top">
                          <i class="icofont icofont-ui-edit" aria-hidden="true"></i>
                        </a>
                      </div>
                      <div class="btn-group rightdropdown" dropdown *ngIf="(authService.Broker() || authService.Admin()|| authService.SuperAdmin()) && (offer.IsDraft == false)">
                        <span *ngIf="offer.StatusId==466 || offer.StatusId==467" class="tooptip-lg tooltip-warrning">
                          <i class="fa fa-info-circle" tooltip="Offer is either canceled or declined" placement="left" style="color:red;font-size:14px;" aria-hidden="true"></i>
                        </span>
                        <button id="button-basic" [ngClass]="{'disable-link':IsPDeleted}" dropdownToggle type="button" class="blueone dropdown-toggle"
                                aria-controls="dropdown-basic">
                          <i class="fa fa-cog" tooltip="Change Offer Status" aria-hidden="true"></i>
                        </button>
                        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                          <li *ngFor="let statusItem of statusListFilter(offer.StatusId)"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(statusItem.id,offer.LeadId,offer.OfferDetailGuid)">{{statusItem.description}}</a></li>
                        </ul>
                      </div>
                      <div class="btn-group rightdropdown" dropdown *ngIf="(authService.Broker() || authService.Admin() || authService.SuperAdmin() || authService.Principal() || authService.Principal1031())">
                        <button id="button-basic" dropdownToggle type="button" class="blueone dropdown-toggle"
                                aria-controls="dropdown-basic">
                          <i class="fa fa-ellipsis-v" aria-hidden="true" tooltip="More Actions"></i>
                        </button>
                        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                          <li>
                            <a *ngIf="authService.Admin() || authService.SuperAdmin() || this.authService.Broker()" class="dropdown-item" href="javascript:void(0);" (click)="openModal(template,'deletemodal',offer.LeadId,index)">Remove Offer</a>
                            <!--<a class="remove" tooltip="Remove" href="javascript:void(0);" (click)="openModal(template,'deletemodal',offer.LeadId,index)"><i class="icofont icofont-close" aria-hidden="true"></i></a>-->
                          </li>
                          <li>
                            <a class="dropdown-item" href="javascript:void(0);" (click)="openUploadFileModal(uploadFile,offer.OfferDetailGuid,offer.Id,'portfolio-bov-modal')">LOI And Documents</a>
                          </li>
                          <li>
                            <a *ngIf="this.authService.Broker() && !offer.IsDraft && (offer.QuestionareIsDraft||(offer.NotAnsweredQustionsCount)!=34) &&offer.IsHaveRemainderPermission==1&&offer.OfferType!='1031 Exchange'" href="javascript:void(0);" (click)="SendBuyerQuestionsRemainder(offer.LeadId)" class="dropdown-item" placement="top">
                              Send Questionnaire Reminder
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>


                    <!--<div class="btn-group rightdropdown" dropdown container="body" *ngIf="(authService.Principal() || authService.Principal1031() || authService.ExternalBroker())&& !isPropertySeller && (offer.StatusId==451 || offer.StatusId==461) && !offer.IsDraft">
                        <button id="button-basic" dropdownToggle type="button" class="blueone dropdown-toggle"
                                aria-controls="dropdown-basic">
                            <i class="fa fa-cog" aria-hidden="true"></i>
                        </button>
                        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                            <li *ngFor="let statusItem of statusListFilter(offer.StatusId)"><a class="dropdown-item" href="javascript:void(0);" (click)="changeOfferStatus(statusItem.id,offer.LeadId,offer.OfferDetailGuid)">{{statusItem.description}}</a></li>
                        </ul>
                    </div>-->

                  </td>
                  <td class="whitespacenowrap" *ngIf="(authService.Broker()||authService.Principal()||authService.Principal1031()||authService.ExternalBroker() || authService.Admin() || authService.SuperAdmin())&&offer.IsHaveQuestionPermission==1&&offer.OfferType!='1031 Exchange'">
                    <p><a href="javascript:void(0);" *ngIf="!offer.IsDraft" (click)="openBuyerModal(BuyerQuestinnaire,'commonmodal modal-buyer-questionnaire',offer.LeadId,offer.PropertyId)">{{offer.NotAnsweredQustionsCount}} / 34</a></p>
                    <span *ngIf="offer.QuestionareIsDraft&&!offer.IsDraft" class="red">(Draft)</span>
                    <span *ngIf="offer.IsDraft">-</span>
                  </td>
                  <td class="whitespacenowrap" *ngIf="(authService.Broker()||authService.Principal()||authService.Principal1031()||authService.ExternalBroker() || authService.Admin()|| authService.SuperAdmin())&&offer.IsHaveQuestionPermission!=1&&offer.OfferType!='1031 Exchange'">
                    <p><a href="javascript:void(0);" *ngIf="!offer.QuestionareIsDraft&&offer.IsHaveRemainderPermission==1&&!offer.IsDraft" (click)="openBuyerModal(BuyerQuestinnaire,'commonmodal modal-buyer-questionnaire',offer.LeadId,offer.PropertyId)">{{offer.NotAnsweredQustionsCount}} / 34</a></p>
                    <span *ngIf="(offer.QuestionareIsDraft||offer.IsHaveRemainderPermission!=1||offer.IsDraft)">-</span>
                  </td>
                  <td *ngIf="(this.authService.Broker()||this.authService.Principal()||this.authService.Principal1031()||this.authService.ExternalBroker()||authService.Admin()||authService.SuperAdmin())&&offer.OfferType=='1031 Exchange'">
                    <span>-</span>
                  </td>
                  <td class="whitespacenowrap tooptip-lg">
                    <p *ngIf="isFromPortfolio">
                      <span *ngIf="(this.authService.Principal()||this.authService.Principal1031())&&!isPropertySeller">{{offer.LeadName}}</span>
                      <a *ngIf="(this.authService.Principal()||this.authService.Principal1031())&&isPropertySeller" href="javascript:void(0);" routerLink="/offer-detail/{{offer.OfferDetailGuid}}" [queryParams]="{prevroute:'Property Details', link:router.url}">{{offer.LeadName}}</a>
                      <a *ngIf="(!this.authService.Principal()&&!this.authService.Principal1031())" href="javascript:void(0);" routerLink="/offer-detail/{{offer.OfferDetailGuid}}" [queryParams]="{prevroute:'Property Details', link:router.url}">{{offer.LeadName}}</a>
                    </p>
                    <p *ngIf="!isFromPortfolio">
                      <a href="javascript:void(0);" routerLink="/offer-detail/{{offer.OfferDetailGuid}}" [queryParams]="{prevroute:'Property Details', link:router.url}">{{offer.LeadName}}</a>
                    </p>
                    <p *ngIf="offer.BuyerName">on behalf of {{offer.BuyerName}}</p>
                    <p>({{getofferPlacedUserRole(offer.UserRole)}})</p>
                  </td>
                  <td>{{offer.TradeName ? offer.TradeName : '-'}}</td>


                  <td class="whitespacenowrap">{{offer.LastModifiedUser}}</td>

                  <td>
                    <p class="d-flex whitespacenowrap">
                      <span class="btn-collapse" *ngIf="offer.PropertyOrPortfolio != 'Single'" (click)="showPortfolioProperties(offer.OfferDetailGuid, p,i)"><i aria-hidden="true" class="fa fa-angle-right"></i></span>{{offer.PropertyOrPortfolio}}
                    </p>
                  </td>
                  <td>{{offer.OnBehalfOf}}</td>
                  <td class="whitespacenowrap" [hidden]="hideBroker">
                    <p>{{ offer.PrimaryContactName }}</p>
                    <!--<p *ngIf="offer.SecondaryContactNames">{{ offer.SecondaryContactNames }}</p>-->
                  </td>
                  <td>
                    <p class="whitespacenowrap" *ngIf="!offer.Unpriced">{{(offer.Price) ? '$ '+(offer.Price |number:0) : '-'}}</p>
                    <p class="whitespacenowrap" *ngIf="offer.Unpriced">Unpriced</p>
                  </td>
                  <!--<td><p class="whitespacenowrap">{{offer.OfferType}}</p></td>-->
                  <td class="whitespacenowrap"><p>{{convertUTCDateToLocalOfferDate(offer.OfferDate)| date:'MM/dd/yyyy'}}</p></td>
                  <td><p class="whitespacenowrap">{{(offer.OfferPrice) ? '$ '+(offer.OfferPrice |number:0) : '-'}}</p></td>
                  <td><p class="whitespacenowrap">{{(offer.CapRate) ? (offer.CapRate |number:0) +' %' : '-'}}</p></td>

                  <td><p class="whitespacenowrap">{{(offer.EarnestMoneyDeposit) ? '$ '+(offer.EarnestMoneyDeposit |number:0) : '-'}}</p></td>
                  <td>{{(offer.DueDiligencePeriod) ? (offer.DueDiligencePeriod | number:0) : '-'}}</td>
                  <td>{{(offer.ClosingPeriod) ? (offer.ClosingPeriod | number:0) : '-'}}</td>
                  <!--<td><p  class="ellipsis-text commentpara">{{offer.Comments}}<button class="eyeicon" container="body" triggers="focus" popover="{{offer.Comments}}"><i class="fa fa-eye" aria-hidden="true"></i></button></p></td>-->
                  <td>{{offer.StatusName =='Cancelled' ? 'Canceled' :offer.StatusName}}<span *ngIf="offer.IsDraft" class="red">(Draft)</span></td>
                  <td (click)="(this.authService.Admin() || this.authService.Broker()|| this.authService.SuperAdmin()) && !IsPDeleted && openStarRatingModal(templateStarRating,'deletemodal starratingmodal',offer.LeadOfferId,setRating(offer.Rating),offer.Rating)">
                    <div class="starouter">
                      <span *ngFor="let star of setRating(offer.Rating);let star1 of rating;let i=index" tooltip="{{(this.authService.Admin() || this.authService.Broker() || this.authService.SuperAdmin())? i+1 : ''}}" style="{{(this.authService.Admin() || this.authService.Broker()||this.authService.SuperAdmin())? 'cursor:pointer;' : ''}}">
                        <i class="fa" [ngClass]="{'fa-star':(star === 1),'fa-star-o':(star === 0) }"></i>
                      </span>
                    </div>
                  </td>

                </tr>
                <ng-container *ngIf="offer.ShowPortfolio">
                  <tr *ngFor="let prop of offer.PortfolioProperties; let k=index" (click)="selecteRow(k)" [class]="(authService.Principal() || authService.Principal1031()) ? (prop.IsViewed == 0 ? 'unvisited':'visited'): '' " [class.tr-collapse]="offer.PropertyOrPortfolio != 'Single'">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td class="whitespacenowrap">
                      <p *ngIf="haveaccesstoviewlocation"><a href="javascript:void(0);" routerLink="/viewproperty/{{prop.Guid}}" [queryParams]="{ prevroute:'Portfolio Details' , link:redirectLink}">{{prop.PropertyName + ", " + prop.City + ", " + prop.State}}</a></p>
                      <p *ngIf="!haveaccesstoviewlocation">
                        <a href="javascript:void(0);" routerLink="/viewproperty/{{prop.Guid}}" [queryParams]="{ prevroute:'Portfolio Details' , link:redirectLink}" *ngIf="prop.ConfidentialLocation">{{prop.PropertyName + ", Confidential"}}</a>
                        <a href="javascript:void(0);" routerLink="/viewproperty/{{prop.Guid}}" [queryParams]="{ prevroute:'Portfolio Details' , link:redirectLink}" *ngIf="!prop.ConfidentialLocation">{{prop.PropertyName + ", " + prop.City + ", " + prop.State}}</a>
                      </p>
                    </td>
                    <td></td>
                    <td [hidden]="hideBroker"></td>
                    <td><p class="whitespacenowrap">{{(prop.Price) ? '$ '+(prop.Price |number:0) : '-'}}</p></td>
                    <!--<td><p class="whitespacenowrap">{{prop.OfferType}}</p></td>-->
                    <td class="whitespacenowrap"><p>{{convertUTCDateToLocalOfferDate(offer.OfferDate)| date:'MM/dd/yyyy'}}</p></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <!--<th>Comments</th>-->
                    <td></td>
                    <td></td>
                  </tr>
                </ng-container>
              </ng-container>

            </ng-container>
          </ng-container>

        </tbody>
        <tfoot>
          <tr *ngIf="unChangedofferList?.length == 0&&!IsLoading ">
            <td colspan="17" class="odd no-data-available">
              <div class="nodata">
                <i class="fa fa-exclamation-triangle icon"></i>
                <p>No offers on this Property.</p>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

</div>
<br />


<ng-template #template>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Offer Details</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to delete this offer?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
      <button class="btn btn-lg btn-danger" (click)="deleteOffers();modalRef.hide();">Delete</button>
    </div>
  </div>

</ng-template>

<ng-template #acceptcountertemplate>
  <app-offer-status-change (close)="closeModal" [modalRef]="modalRef" [offerGuid]="offerGuid" [showAccept]="showAccept" (acceptedOffer)="offerAccepted($event)"></app-offer-status-change>
</ng-template>

<ng-template #rejectcountertemplate>
  <app-offer-status-change (close)="closeModal" [modalRef]="modalRef" [offerGuid]="offerGuid" [showAccept]="showAccept"></app-offer-status-change>
</ng-template>

<ng-template #deletetemplate>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Cancel Offer {{popupheading}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to cancel this offer?</h6>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">No</button>
      <button class="btn btn-lg btn-primary" (click)="ChangeStatus();modalRef.hide();">Yes</button>
    </div>
  </div>

</ng-template>

<ng-template #declinetemplate>

  <div class="modal-header">
    <h4 class="modal-title pull-left">Decline Offer {{popupheading}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">

    <div class="form-group">
      <h6 class="displayvalue">Are you sure you want to decline this offer?</h6>
    </div>
    <div class="text-right">

      <button class="btn btn-lg btn-danger" (click)="ChangeStatus();modalRef.hide();">Yes</button>
      <button class="btn btn-lg btn-default" (click)="modalRef.hide()">No</button>
    </div>
  </div>

</ng-template>
<ng-template #templateStarRating>

  <div class="modal-body padding30">
    <h6 class="displayvalue margin-bottom-5">Update Rating</h6>
    <div class="stars">
      <span *ngFor="let star of rating;let i=index" (click)="setStar(i,idToRate)" tooltip="{{i+1}}" style="cursor:pointer;">
        <i class="fa" [ngClass]="{'fa-star':(star === 1),'fa-star-o':(star === 0) }"></i>
      </span>
    </div>
    <div class="text-right">
      <button class="btn btn-lg btn-default" (click)="onClose(true)">Cancel</button>
      <button *ngIf="starRating > 0" class="btn btn-lg btn-danger" (click)="setStar(-1,idToRate)">Remove</button>
    </div>
  </div>
</ng-template>

<!--<ng-template #templateOfferPopup>
  <app-offer-edit (close)="closeModal($event)" [leadGUID]="leadGUID"></app-offer-edit>
</ng-template>-->

<ng-template #templateOfferPopup>
  <div class="modal-body padding30">
    <div class="modal-header">
      <h4 class="modal-title pull-left">Offer Details</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="margin-top-15">
      <app-offer-edit (close)="closeModal($event)" [LivePropertyGuid]="propertyGuid" [leadGUID]="leadGUID"></app-offer-edit>
    </div>
  </div>

</ng-template>

<ng-template #BuyerQuestinnaire>
  <app-Buyer-Questionnaire [modalBuyerRef]="modalBuyerRef" [OfferId]="BuyerQuestionsOfferId" [PropertyId]="BuyerQuestionsPropertyId" [source]="'OfferList'" [PropertyGuid]="propertyGuid"></app-Buyer-Questionnaire>
</ng-template>

<ng-template #uploadFile>
<app-property-offer-document-upload [inputOfferGuid]="leadGUID" [leadName]="leadName" [offerPrice]="offerPrice" [placedDate]="placedDate" [RefreshTab] ="'Offer-Files'" (close)="onClose()" [fileTypes]="fileTypes"></app-property-offer-document-upload>
  </ng-template>
